import { createAction } from 'vuex-action';
import axios from 'axios';

const fetchMe = createAction('fetchMe', async () => {
  const reply = await axios.get('/me')
    .then(response => response)
    .catch(e => e.response);
  if (reply.status === 500 || reply.status === 401) return false;
  return reply.data;
});

export default {
  state: {
    title: '',
    me: null,
  },
  mutations: {
    setTitle(state, title) {
      state.title = title;
    },
    [fetchMe](state, me) {
      state.me = me;
    },
  },
  actions: {
    fetchMe,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js